export const appApiUrls = {
  appStatus: '/api/v1/app-status',
  changeLanguage: '/api/v1/change-language',
  globalSearch: '/api/v1/global-search',
};
